import type { Profile } from "../../data/site";
import { Button } from "../ui/Button";
import { scrollToId } from "../../utils/scroll";
import "./hero.css";

export function Hero({
  profile,
  researchInterests
}: {
  profile: Profile;
  researchInterests: string[];
}) {
  return (
    <div className="hero" data-reveal>
      <div className="hero__left">
        <div className="hero__kicker">{profile.city}</div>
        <h1 className="hero__name">
          {profile.nameZh} <span className="hero__nameEn">{profile.nameEn}</span>
        </h1>
        <p className="hero__title">{profile.tagline}</p>
        <p className="hero__intro">{profile.intro}</p>

        <div className="hero__meta">
          <div className="pill">城市：{profile.city}</div>
          <a className="pill pill--link" href={`mailto:${profile.email}`} aria-label="邮件联系">
            {profile.email}
          </a>
          <div className="pill" aria-label="手机号（默认不完整展示）">
            手机：{profile.phoneMasked}
          </div>
        </div>

        <div className="hero__cta">
          <Button href={`mailto:${profile.email}`} iconRight={<span aria-hidden>→</span>}>
            发邮件联系
          </Button>
          <Button
            variant="secondary"
            iconRight={<span aria-hidden>↓</span>}
            onClick={() => scrollToId("contact")}
          >
            联系方式
          </Button>
        </div>
      </div>

      <div className="hero__right">
        <div className="hero__avatarWrap">
          <img className="hero__avatar" src={profile.avatarUrl} alt={`${profile.nameZh} 头像`} />
        </div>
        <div className="hero__highlights">
          <div className="hero__highlightsTitle">研究兴趣</div>
          <ul className="hero__list">
            {researchInterests.map((x) => (
              <li key={x}>{x}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

